/**
 * Reads the id out of a loosely-typed CDF param value, which may be a
 * GeckoView/GeckoSource-like object, a bare string, or null/undefined.
 */
export function paramId(value: unknown): string | undefined {
  if (typeof value === 'string') return value
  if (value && typeof value === 'object' && 'id' in value) {
    return String((value as { id: unknown }).id)
  }
  if (value === undefined || value === null) return undefined
  return String(value)
}

export function paramName(value: unknown): string | undefined {
  if (value && typeof value === 'object' && 'name' in value) {
    return String((value as { name: unknown }).name)
  }
  return undefined
}
